/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var dialog_triggers = document.querySelectorAll('[data-open-dialog]');
  if(dialog_triggers) {
    dialog_triggers.forEach((dialog_trigger) => {
      var dialog = document.getElementById(dialog_trigger.getAttribute('data-open-dialog'));

      if(!dialog) {
        console.error('Dialog was not found', dialog_trigger);
        return;
      }

      // Allow clicking outside the dialog for browsers that don't yet support it
      dialog.addEventListener("click", e => {
        const dialogDimensions = dialog.getBoundingClientRect();
        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          dialog.classList.remove('dialog-open');
          dialog.close();
        }
      });

      var dialog_close = dialog.querySelector('[data-close-dialog]');
      if(dialog_close) {
        dialog_close.addEventListener('click', (e) => {
          e.preventDefault();
          dialog.classList.remove('dialog-open');
          dialog.close();
        });
      } else {
        console.log('No close button found for dialog', dialog);
      }

      dialog_trigger.addEventListener('click', (e) => {
        e.preventDefault();

        const eventOpen = new CustomEvent('dialog-open', {
          bubbles: false,
          detail: { trigger: dialog_trigger }
        });

        dialog.dispatchEvent(eventOpen);

        dialog.classList.add('dialog-open');
        dialog.showModal();

        dialog.querySelector('[data-close-dialog]').focus();
      });
    });
  }
}());